import { Check } from "lucide-react";
import { Reveal } from "./Reveal";
import { IMAGES } from "../../data/site";

const POINTS = [
  "Atendimento ao domicílio em Lisboa e região",
  "Produtos ecológicos e equipamentos adequados",
  "Limpeza, frescura e cuidado em cada estofo",
];

export const About = () => (
  <section id="sobre" className="py-20 lg:py-28" data-testid="about-section">
    <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8">
      <Reveal>
        <div className="relative">
          <div className="absolute -inset-3 rotate-2 rounded-[2.2rem] bg-gradient-to-br from-brand/10 to-aqua/15" aria-hidden="true" />
          <img
            src={IMAGES.about}
            alt="Profissional de limpeza a realizar higienização ao domicílio"
            loading="lazy"
            className="relative aspect-[4/3] w-full rounded-[2rem] object-cover shadow-2xl shadow-navy/15"
            data-testid="about-image"
          />
          <div className="glass-nav absolute -bottom-5 left-6 rounded-2xl border border-white/60 px-5 py-4 shadow-xl shadow-navy/10">
            <p className="font-heading text-sm font-extrabold text-navy">TopEstofos</p>
            <p className="text-xs text-slate-500">Higienização e cuidado que transforma</p>
          </div>
        </div>
      </Reveal>

      <div>
        <Reveal>
          <span className="inline-flex items-center gap-2 font-mono text-xs font-semibold uppercase tracking-[0.22em] text-aqua">
            <span className="text-brand/60">06</span>
            <span className="h-px w-6 bg-aqua/50" aria-hidden="true" />
            Sobre nós
          </span>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-4 text-balance text-3xl font-extrabold tracking-tight text-navy sm:text-4xl">
            Qualidade e cuidado em cada serviço
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mt-5 text-base leading-relaxed text-slate-500 md:text-lg">
            A TopEstofos nasceu com o objetivo de proporcionar uma solução profissional e
            conveniente para a higienização de estofos em Lisboa e região.
          </p>
          <p className="mt-4 text-base leading-relaxed text-slate-500 md:text-lg">
            Trabalhamos com atendimento ao domicílio, produtos ecológicos e equipamentos adequados
            para devolver limpeza, frescura e cuidado aos seus estofos.
          </p>
        </Reveal>
        <Reveal delay={0.24}>
          <ul className="mt-7 space-y-3">
            {POINTS.map((point) => (
              <li key={point} className="flex items-center gap-3 text-sm font-medium text-navy">
                <span className="grid h-6 w-6 shrink-0 place-items-center rounded-full bg-brand/10">
                  <Check className="h-3.5 w-3.5 text-brand" strokeWidth={3} />
                </span>
                {point}
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </div>
  </section>
);
